<template>
  <card-panel :id="jobsContainerIdState" :paddinglessContent="!!applicationsListState.length" class="jobs-container">
    <span v-translate slot="header-name" class="header">jobs</span>
    <counter-tag slot="header-counter">{{ applicationsListState.length }}</counter-tag>

    <div slot="content">
      <div v-if="profileLoadingState || applicationsLoadingState || createApplicationLoadingState" class="loader"></div>
      <div v-else>
        <applications-card-list
          v-show="applicationsListState.length"
          :items="applicationsListState"
          :clickable="true"
          @click="redirectToJobPage">
        </applications-card-list>
        <div v-show="!applicationsListState.length">
          <div v-if="isJustRegistered">
            <span>{{ labels.beforeContact }}</span>
            <div class="file is-centered ">
              <hand-phone-call-illustration class="before-contact-img"></hand-phone-call-illustration>
            </div>
          </div>
          <div v-else>
            <p>{{ labels.relax }}</p>
            <span class="margin-top">{{ labels.afterContact }}</span>
            <sit-back-relax-couple-illustration class="after-contact-img"></sit-back-relax-couple-illustration><div class="is-clearfix"></div>
          </div>
        </div>
      </div>
    </div>

  </card-panel>
</template>

<script>

import CardPanel from 'top20common/components/card-panel/CardPanel';
import CardPanelList from 'top20common/components/card-panel/CardPanelList';
import CounterTag from 'top20common/components/text-blocks/CounterTag';
import formatter from 'top20common/distribution/services/formatter';
import {mapGetters} from 'vuex';
import HandPhoneCallIllustration from 'top20common/components/illustrations/HandPhoneCallIllustration';
import SitBackRelaxCoupleIllustration from 'top20common/components/illustrations/SitBackRelaxCoupleIllustration';
import ApplicationsCardList from './ApplicationsCardList';

export default {
  computed: {
    ...mapGetters([
      'profileDetailsState',
      'profileLoadingState',
      'applicationsLoadingState',
      'applicationsListState',
      'jobsContainerIdState',
      'createApplicationLoadingState'
    ]),
    isJustRegistered() {
      return this.profileDetailsState.status === 'registered';
    },
    labels() {
      return {
        relax: this.$gettext('Sit back. Relax.'),
        beforeContact: this.$gettext(
          'Your Talent Advisor will contact you soon to discuss what your ideal next opportunity could look like.'
        ),
        afterContact: this.$gettext(
          'As soon as an opportunity comes along that matches your background and experience, we’ll contact you.'
        )
      };
    }
  },
  methods: {
    redirectToJobPage(item) {
      if (item.code) {
        let jobSlug = formatter.slugify(item.job_title);
        this.$router.push(`/jobs/${item.code}/${jobSlug}`);
      }
    }
  },
  components: {
    CardPanel,
    CounterTag,
    CardPanelList,
    ApplicationsCardList,
    HandPhoneCallIllustration,
    SitBackRelaxCoupleIllustration
  }
};
</script>

<style lang="scss" scoped>
@import '~VariablesStyles';

.after-contact-img {
  width: 65%;
  margin-right: 20px;
  margin-top: -65px;
  float: right;
}

/deep/ .card-panel-list {
  padding: 10px 0;

  & > *:not(:last-child) {
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid var(--light-gray);
  }
}

@media screen and (max-width: $tablet) {
  .after-contact-img {
    width: 100%;
    margin-right: 0;
  }
}

.before-contact-img {
  height: 163px;
  margin-top: 20px;
}
</style>
